export const imageMixin = {
    methods: {
        textToVerticalImage (text, size) {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            ctx.canvas.width = 11;
            ctx.canvas.height = size || ctx.measureText(text).width;
            ctx.font = `bold 11px 'Roboto Condensed', Arial, Sans-serif`;
            ctx.rotate(-Math.PI / 2);
            ctx.textAlign = 'right';
            ctx.fillText(text, 0, 10);
            return ctx.canvas.toDataURL();
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/shared/mixins/image.mixin.js